// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"113435cf","187":"8bff892e","564":"113435cf"}[chunkId] + ".chunk.css";
};